export default function(store, action) {

  //console.log(store, action)
  return {
    ...store,
    roomsExpanded: action.configuration.switch_status === '1',
    config: { ...store.config, ...action.configuration },
    configLoading: false
  }
}
